import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { catchError, map, Observable, of } from 'rxjs';
import { AuthService } from '../../../core/auth/services/auth.service';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ImagesService {

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private sanitizer: DomSanitizer
  ) {}

  getSecureImageUrl(path: string): Observable<SafeUrl | null> {
    if (!path) return of(null);

    const token = this.authService.getToken();
    const headers = token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : undefined;

    const startWithHttp = path.startsWith('http');
    const url = startWithHttp ? path : `${environment.api_url}${path}`;

    return this.http.get(url, { responseType: 'blob', headers }).pipe(
      map(blob => {
        const blobUrl = URL.createObjectURL(blob);
        return this.sanitizer.bypassSecurityTrustUrl(blobUrl);
      }),
      catchError(() => of(null))
    );
  }
}
